<template>
  <div class="myreport">
    <!-- <h2>myReport</h2> -->
    <van-nav-bar left-arrow class="nucleicAcidTestNav">
      <template #title>
        <p class="headertext">我的报告</p>
      </template>
      <template #left>
        <van-icon color="#fff" name="arrow-left" size="18" @click="returnPage" />
      </template>
    </van-nav-bar>
    <div class="myreport_body">
      <div id="pdf"></div>
    </div>
    <div class="myreport_foot">
      <div @click="exportRes">点击下载</div>
      <div @click="savePic" class="btn_shadow">
        保存到相册
        <span></span>
      </div>
    </div>
  </div>
</template>


<script>
import Pdfh5 from "pdfh5"
import "pdfh5/css/pdfh5.css"
import { Toast } from "vant"
import html2canvas from "html2canvas"
import { getCookie } from "@/utils/common"
export default {
  name: "myReport",
  data() {
    return {
      pdfh5: null,
      pdfUrl: "",
      deptId: "",
      id: ""
    }
  },
  mounted() {
    let { deptId, id } = this.$route.query
    this.deptId = deptId
    this.id = id
    this.request({
      baseURL: process.env.VUE_APP_PAY_URL,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json;charset=utf8",
         "Authorization":getCookie("token")
      },
      url:
        "/natOrderUser/downloadNatReportPdfH5/" +
        this.id +
        "/" +
        this.deptId +
        "/" +
        new Date().getTime()
    }).then((res) => {
      let url = window.URL.createObjectURL(new Blob([res.data]))
      this.pdfh5 = new Pdfh5("#pdf", {
        pdfurl: url,
        goto: 1,
        logo: {
          x: 420,
          y: 700,
          width: 120,
          height: 120
        }
      })
      this.pdfh5.on("complete", (status, msg, time) => {
        console.log(
          "状态:" + status + "，信息:" + msg + "，耗时:" + time + "毫秒"
        )
      })
    })

    // console.log(this.pdfUrl)

    // 监听pdf准备开始渲染，此时可以拿到pdf总页数

    // 监听pdf加载完成事件，加载失败、渲染成功都会触发
  },
  methods: {
    returnPage() {
      this.$router.go(-1)
    },
    exportRes() {
      const machineType =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
          ? "Mobile"
          : "Desktop"
      if (machineType === "Mobile") {
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          message: "系统限制，移动端只能长按图片保存",
          status: "1",
        })
      } else {
        let ua = navigator.userAgent.toLowerCase()
        console.log(ua)
        if (ua.includes("mac")) {
          Toast.loading({
            message: "加载中...",
            forbidClick: true,
            duration: 0
          })
          this.request({
            baseURL: process.env.VUE_APP_PAY_URL,
                   responseType: "blob",
              headers: {
          "Content-Type": "application/json;charset=utf8"
        },
            url:
              "/natOrderUser/downloadNatReportPdfH5/" +
              this.id +
              "/" +
              this.deptId +
              "/" +
              new Date().getTime()
          }).then((res) => {
            Toast.clear()
            if (res.data.code == -1) {
              Dialog.alert({
                title: "提示",
                message: res.data.message,
                confirmButtonColor: "#00DB9B",
                getContainer: ".nucleicAcidTestMain"
              }).then(() => {})
            } else {
              let url = window.URL.createObjectURL(new Blob([res.data]))
              console.log(url)
              let link = document.createElement("a")
              link.style.display = "none"
              link.href = url
              link.setAttribute("download", "核酸检测报告" + ".pdf")
              document.body.appendChild(link)
              link.click()
            }
          })
        } else {
          Toast.loading({
            message: "加载中...",
            forbidClick: true,
            duration: 0
          })
          this.request({
            baseURL: process.env.VUE_APP_PAY_URL,
            responseType: "blob",
              headers: {
          "Content-Type": "application/json;charset=utf8"
        },
            url:
              "/natOrderUser/downloadNatReportPdfH5/" +
              this.id +
              "/" +
              this.deptId +
              "/" +
              new Date().getTime()
          }).then((res) => {
            Toast.clear()
            if (res.data.code == -1) {
              Dialog.alert({
                title: "提示",
                message: res.data.message,
                confirmButtonColor: "#00DB9B",
                getContainer: ".nucleicAcidTestMain"
              }).then(() => {})
            } else {
              console.log(22)
              let url = window.URL.createObjectURL(new Blob([res.data]))
              console.log(url)
              let link = document.createElement("a")
              link.style.display = "none"
              link.href = url
              link.setAttribute("download", "核酸检测报告" + ".pdf")
              document.body.appendChild(link)
              link.click()
            }
          })
        }
      }
    },
    savePic() {
      const machineType =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
          ? "Mobile"
          : "Desktop"
      if (machineType === "Mobile") {
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          message: "系统限制，移动端只能长按图片保存",
          status: "1",
        })
      } else {
        html2canvas(document.querySelector(".myreport_body"), {
          allowTaint: false, //允许污染
          taintTest: true, //在渲染前测试图片(没整明白有啥用)
          useCORS: true, //使用跨域(当allowTaint为true时这段代码没什么用)
          background: "#fff"
        }).then((image) => {
          url = image.toDataURL("image/jpeg", 1.0)
          // 将截图展示在test div中
          let Url = url //图片路径，也可以传值进来
          var triggerEvent = "touchstart" //指定下载方式
          var blob = new Blob([""], { type: "application/octet-stream" }) //二进制大型对象blob
          var url = URL.createObjectURL(blob) //创建一个字符串路径空位
          var a = document.createElement("a") //创建一个 a 标签
          a.href = Url //把路径赋到a标签的href上
          a.download = Url.replace(/(.*\/)*([^.]+.*)/gi, "$2").split("?")[0]

          var e = new MouseEvent(
            "click",
            (true,
            false,
            window,
            0,
            0,
            0,
            0,
            0,
            false,
            false,
            false,
            false,
            0,
            null)
          )
          //派遣后，它将不再执行任何操作。执行保存到本地
          a.dispatchEvent(e)
          //释放一个已经存在的路径（有创建createObjectURL就要释放revokeObjectURL）
          URL.revokeObjectURL(url)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.headertext {
  font-family: PingFangSC-Semibold;
  font-size: 17px;
  color: #fff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 600;
}
.btn_shadow {
  position: relative;
  z-index: 1;

  > span {
    position: absolute;
    width: 90%;
    background: url("../../assets/newhs/ljyy.png") 0 0 no-repeat;
    background-size: 100% 100%;
    border-radius: 0.58667rem;
    height: 0.96rem;
    left: 50%;
    margin-left: -45%;
    bottom: -18px;
    z-index: 0;
  }
}
.myreport {
  height: 100vh;
  // background: url("../../assets/newhs/dwbg.png") 0 0 no-repeat !important;
  background-size: 100% 100%;
  overflow-y: auto;
  .van-hairline--bottom::after {
    border: 0 !important;
  }
}
.myreport_body {
  margin-top: 40px;
  height: calc(100vh - 144px);
}
.myreport_foot {
  // position: fixed;
  bottom: 30px;
  height: 88px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: #fafafa;
  > div {
    width: 45%;
    height: 44px;
    line-height: 44px;
    text-align: center;
  }
  > div:first-child {
    background: #ffffff;
    border: 1px solid rgba(48, 186, 129, 1);
    border-radius: 22px;

    font-size: 18px;
    color: #30ba81;
    letter-spacing: 0;
    text-align: center;
    font-weight: 500;
    margin-right: 10px;
  }
  div:last-child {
    background-image: linear-gradient(
      115deg,
      #2daf72 0%,
      #30bf83 42%,
      #37cf94 94%
    );
    border-radius: 22px;

    font-size: 18px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    font-weight: 500;
  }
}
</style>
